// extracted by mini-css-extract-plugin
module.exports = {"marquee":"marquee-module--marquee--2X7ps","marquee_one":"marquee-module--marquee_one--1VpiS","marquee_two":"marquee-module--marquee_two--1FR3q"};